import { render, staticRenderFns } from "./DnPolon.vue?vue&type=template&id=5c3f40e4&scoped=true&"
import script from "./DnPolon.vue?vue&type=script&lang=js&"
export * from "./DnPolon.vue?vue&type=script&lang=js&"
import style0 from "./DnPolon.vue?vue&type=style&index=0&id=5c3f40e4&lang=scss&scoped=true&"
import style1 from "./DnPolon.vue?vue&type=style&index=1&id=5c3f40e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f40e4",
  null
  
)

export default component.exports